import interpolate from '#/lib/interpolate.js';
import {
  addInterpolation,
  removeInterpolation,
} from '#/store/slices/interpolation.js';

export default function InterpolationAPI({ store }) {
  return {
    replace: interpolate,
    interpolate,
    add(key, value) {
      store.dispatch(addInterpolation({ key, value }));
      return () => store.dispatch(removeInterpolation({ key }));
    },
    remove(key) {
      store.dispatch(removeInterpolation({ key }));
    },
  };
}
